<template>
	<ScrollView ref="listContainer" class="ListView invert-color">
		<div id="ListViewInnerScroll" ref="listScrollContainer">
			<div class="ListViewItem empty" v-if="!hasItems">
				<span class="Title">List empty...</span>
			</div>
			<div class="ListViewItem" v-for="( item, index ) in items" :class="getClasses(item, index)" ref="listItems"
			     @click="onListItemClick(index)" v-else>
				<span v-if="showIndex" class="Index">{{index + 1}}</span>
				<span v-if="item.level" class="InvisibleIndent">{{new Array(item.level).fill('-').join('')}}</span>
				<span class="Title">{{item.title||item.name}}</span>
			</div>
		</div>
	</ScrollView>
</template>

<script>
	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
	import KeyListenerView from '../KeyListenerView';
	import ScrollView from '../ScrollView';

	@Component({
		components: {
			ScrollView
		},
	})
	export default class ListView extends KeyListenerView {
		@Prop(Array) items;
		@Prop(Boolean) showIndex;
		@Prop({ type: Array, default: () => [['ENTER', 'Select']] }) selectKeyboardListeners;
		selectedIndex = 0;

		get hasItems() {
			return Boolean(this.items && this.items.length);
		}

		getClasses(item, index) {
			const itemClasses = item.class && Array.isArray(item.class) ?
				item.class.reduce((obj, cls) => Object.assign(obj, { [cls]: true }), {}) :
				item.class || {};
			return { ...itemClasses, Selected: item.selected, Active: this.selectedIndex === index };
		}

		mounted() {
			this.addKeyboardListener('DOWN', this.onDownKey, 'Move Up');
			this.addKeyboardListener('UP', this.onUpKey, 'Move Down');
			for (let i = 0; i < 10; i++) {
				this.addKeyboardListener('' + i, this.onDigitKey);
			}
			this.selectKeyboardListeners.forEach(([key, label]) => {
				this.addKeyboardListener(key, this.onSelectKey, label);
			});
			super.mounted();
		}

		destroyed() {
			super.destroyed();
		}

		onDigitKey(digit) {
			this._digits = (this._digits || '') + digit;
			let idx = Number(this._digits) - 1;
			if (idx >= 0 && idx < this.items.length)
				this.selectedIndex = idx;
			setTimeout(() => {
				this._digits = '';
			}, 1000);
		}

		onDownKey() {
			if (this.selectedIndex < this.items.length - 1) {
				this.selectedIndex++;
				this.scrollIfNeeded();
			}
		}

		onUpKey() {
			if (this.selectedIndex > 0) {
				this.selectedIndex--;
				this.scrollIfNeeded();
			}
		}

		scrollIfNeeded() {
			const scrollContainer = this.$refs.listContainer.$el;
			const selectedListEl = this.$refs.listItems[this.selectedIndex];
			const selectedElOffset = selectedListEl.offsetTop - scrollContainer.scrollTop;
			if (selectedElOffset < 0) {
				scrollContainer.scrollTop = Math.max(0, scrollContainer.scrollTop + selectedElOffset);
			} else if (selectedElOffset + selectedListEl.offsetHeight + 3 > scrollContainer.offsetHeight) {
				scrollContainer.scrollTop += selectedElOffset + selectedListEl.offsetHeight + 3 - scrollContainer.offsetHeight;
			}
		}

		onSelectKey() {
			if (!this.items[this.selectedIndex]) return;
			this.scrollIfNeeded();
			this.$emit('selected', this.items[this.selectedIndex]);
		}

		onListItemClick(index) {
			this.selectedIndex = index;
			this.scrollIfNeeded();
			this.onSelectKey();
		}

	}
</script>

<style lang="scss">
	.ListView {
		background: #0002A0;
		color: white;
		border: 2px solid #00FFFE;
		border-top-width: 1px;
		border-bottom-width: 1px;
	}

	.ListViewItem {
		padding: 0.1vmin 0.5vmin;

		> .active {
			background: #FDFD67;
		}

		&.empty .Title {
			color: yellow;
		}
	}

	.ListViewItem.Active {
		background: #FDFD67;
	}

	.ListViewItem.Active .Index {
		color: red;
	}

	.ListViewItem.Active .Title {
		color: red;
	}

	.ListViewItem.Selected {
		background: #ADAAAD;
	}

	.ListViewItem .Index {
		color: #FDFD67;
	}

	.ListViewItem .InvisibleIndent {
		color: transparent;
	}

	.ListViewItem .Index:after {
		content: ") ";
	}
</style>